export default {
  form: {
    gtin: {
      label: 'GTIN',
    },
    pfand: {
      label: 'Depósito de embalagem',
    },
    product_type: {
      label: 'Tipo de produto',
      options: {
        packaged: 'Embalado',
        prepared: 'Preparado',
      },
    },
    packaging_material: {
      label: 'Material de embalagem',
    },
    brand_or_manufacturer: {
      label: 'Marca ou fabricante',
    },
    net_quantity: {
      label: 'Quantidade líquida',
    },
    base_price: {
      label: 'Definir preço por unidade (ex.: por litro para uma bebida)',
      placeholder: 'Preço por unidade',
    },
    alcohol_by_volume_percent: {
      label: 'Percentagem de álcool',
    },
    caffeine_mg_per_100ml: {
      label: 'Cafeína (mg por 100ml de produto)',
    },
    ingredients_text: {
      label: 'Ingredientes',
    },
    allergens_list: {
      label: 'Alergénios',
    },
    additives_list: {
      label: 'Aditivos',
    },
    has_nutrition_table: {
      label: 'Preencher tabela nutricional (por 100{{unit}} de produto)',
    },
    energy_kj: {
      label: 'Energia (kJ)',
    },
    energy_kcal: {
      label: 'Energia (kcal)',
    },
    fat_g: {
      label: 'Gordura',
    },
    saturates_g: {
      label: 'Ácidos gordos saturados',
    },
    carbohydrate_g: {
      label: 'Hidratos de carbono',
    },
    sugars_g: {
      label: 'Açúcar',
    },
    protein_g: {
      label: 'Proteína',
    },
    salt_g: {
      label: 'Sal',
    },
    identifiers: {
      label: 'Identificadores',
    },
  },
};
